module.exports = __webpack_public_path__ + "static/assets/4c1527fc44e5aedde7179e9b10837f1c.png";